import ControlGroupContainer from './components/ControlGroupContainer'
import Title from './components/Title'
import Description from './components/Description'
import Item from './components/Item'
import LinkItem from './components/LinkItem'
import LinkLabel from './components/LinkLabel'
import Footer from './components/Footer'
import Selector from './components/Selector'
import {Button, InlineEdit, ToggleSwitch, Custom} from './components/Controls'

export const ControlGroup = Object.assign(ControlGroupContainer, {
  Item,
  LinkItem,
  LinkLabel,
  Title,
  Description,
  Custom,
  ToggleSwitch,
  Button,
  InlineEdit,
  Selector,
  Footer,
})

export type {Mode} from './types'
